export const triageBase = () => {
    return {
        who: null,
        whoUserName: null,
        when: null,

        triageClinicians: null,

        presentation: null,
        discriminator: null,
        dependency: null,
        dependencyTriage: null,

        analgesia: false,
        analgesiaRefused: false,
        analgesiaDetails: '',

        analgesiaPrior: false,
        analgesiaPriorDetails: '',

        analgesiaSAT: false,
        analgesiaSATDetails: '',

        chiefComplaint: null,
        chiefComplaintAuthor: '',

        safeguardingConcerns: false,
        safeguardingConcernsDetails: '',
        safeguarding: [],

        childProtectionConcerns: false,
        childConcernsDetails: '',

        patientWeight: '',
        patientWeightUnits: 'kg',
        presentingComplaint: '',
        presentingComplaintAuthor: '',
        historicPresentingComplaint: '',
        historicPresentingComplaintAuthor: '',
        pastMedicalHistory: null,
        pastMedicalHistoryAuthor: null,
        allergies: null,
        allergiesAuthor: null,
        medications: null,
        medicationsAuthor: null,
        socialHistory: null,

        examination: '',

        investigations: [],
        investigationsTriage: [],

        investigationsDetails: '',
        treatmentAndManagementPlan: [],
        treatmentAndManagementPlanTriage: [],

        treatmentAndManagementPlanDetails: '',
        additionalInformation: '',

        observationNotRequired: false,
        observationNotRequiredTimestamp: null,
        savedObservationId: null,

        painScore: 0,
        painScoreId: '',

        firstWho: null,
        firstWhoUserName: null,
        firstWhen: null,
        firstDiscriminator: null,
    };
};

export const getAcuityPriority = (priority) => {
    if (!priority) return null;

    // MTS version
    if (priority.hasOwnProperty('priority')) {
        return priority?.priority;
    } else if (priority?.__description) {
        // ECDS version
        const char = priority?.__description?.charAt(0);
        return Number(char);
    }
};

export const getTriageButtonColorMatrix = (discriminator) => {
    if (!discriminator) return null;

    if (discriminator?.hasOwnProperty('color')) {
        return discriminator?.color;
    } else if (discriminator) {
        const priority = getAcuityPriority(discriminator);
        switch (priority) {
            case 1:
                return '#DC4A5D';
            case 2:
                return '#F26B28';
            case 3:
                return '#F7F700';
            case 4:
                return '#01AF69';
            case 5:
                return '#2180F7';
            default:
                return '#fff';
        }
    }
};
